import {ReactComponent as CpuLine} from "./assets/cpu-line.svg";
import {ReactComponent as FundsBoxLine} from "./assets/funds-box-line.svg";
import {ReactComponent as InstanceLine} from "./assets/instance-line.svg";
import {ReactComponent as RocketLine} from "./assets/rocket-line.svg";
import {ReactComponent as ServerLine} from "./assets/server-line.svg";

export const customDict = {
  isCustomPage: true,
  isShowVideo: false,
  emailLabel: "账号",
  passWordLabel: "密码",
  customAgreement: true,
  formOffset: 3,
  formCss: "<style>   .login-panel{     border-radius: 2px;     background-color: #ffffff;   }   .login-form {padding: 20px;   background-color: rgba(255, 255, 255, 0.95);  z-index: 2;}  </style>",
};

export const sloganDict = [
  {
    text: "login:Slogan CpuLine",
    icon: <CpuLine />,
  },
  {
    text: "login:Slogan RocketLine",
    icon: <RocketLine />,
  },
  {
    text: "login:Slogan InstanceLine",
    icon: <InstanceLine />,
  },
  {
    text: "login:Slogan FundsBoxLine",
    icon: <FundsBoxLine />,
  },
  {
    text: "login:Slogan ServerLine",
    icon: <ServerLine />,
  },
];
